module.exports = __webpack_public_path__ + "img/cio_banner.78781f3b.png";